// extracted by mini-css-extract-plugin
export default {"title":"Content_title__stfjQ","description":"Content_description__a50oN"};